<template>
  <div class="fullpage_white subpage" style="padding-bottom: 100px">
    <div class="detail_area layout">
      <div class="deposit_container layout feedback_card" style="margin-top: 10px">
        <div class="deposit_header feedback_text">请提供真实信息，有助于您的审核！</div>
        <div class="deposit_body">
          <div class="feedback_sender_form_container">
            <div id="feedback_div">
              <label class="textbox_content displayed_username">
                <input type="text" name="username" id="username" :value="$store.state.userInfo.realname" class="feedback_name un" placeholder="真实姓名" disabled />
                <div class="input_title"></div>
                <div class="error_msg username_error"></div>
              </label>

              <label class="textbox_content">
                <input type="text" placeholder="手机号" v-model="info.mobile" id="title" name="title" class="feedback" />
                <div class="input_title"></div>
                <div class="error_msg title_error"></div>
              </label>
              <label class="textbox_content">
                <textarea placeholder="申请理由" id="message" v-model="info.apply_info" name="message" class="feedback"></textarea>
                <div class="input_title"></div>
                <div class="error_msg message_error"></div>
              </label>
              <label class="textbox_content" @click="shenqing">
                <div class="btn_major feedback_btn">提交申请</div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'apply',
  data() {
    return { info: {} };
  },
  created() {
    let that = this;
  },
  methods: {
    shenqing() {
      console.log(123);
      let that = this;
      that.birthday = $('.ant-picker-input').html();
      let info = that.info;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(info.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }

      if (!info.apply_info) {
        that.$parent.showTost(0, '请输入申请理由');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
          that.showTost(1, res.message);
          that.$parent.hideLoading();
          that.info = {};
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/apply.vue